module.exports = __webpack_public_path__ + "static/img/ding49.1e3a51b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imges/ding49.png
// module id = xLO/
// module chunks = 0